import { render, staticRenderFns } from "./Inteligencia.vue?vue&type=template&id=78da9f3d&scoped=true&lang=pug"
import script from "./Inteligencia.vue?vue&type=script&lang=js"
export * from "./Inteligencia.vue?vue&type=script&lang=js"
import style0 from "./Inteligencia.vue?vue&type=style&index=0&id=78da9f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da9f3d",
  null
  
)

export default component.exports